module.exports = __webpack_public_path__ + "img/sos.ea763a2a.png";